// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__o9RyV","signatureButtonsRight":"ModalSign_signatureButtonsRight__1ylwd"};